import { useQuery } from '@tanstack/react-query';
import { profileService } from '@syscolect/domain';
import { useCurrentUser } from './useCurrentUser.js';
import { useSessionManager } from './useSessionManager.js';
import { useDispatchHookEvent } from '@rammetec/core';
/**
 * Custom hook to get all profiles a user has access to in the current organization.
 *
 * Hook that fetches the list of profiles available to the current user in the active organization.
 */
export const useUserProfiles = () => {
    const { currentUserId, isLoading: isUserLoading } = useCurrentUser();
    const { currentOrganizationId, isLoading: isSessionLoading } = useSessionManager();
    const { data: profiles, isLoading: isProfilesLoading, error } = useQuery({
        queryKey: ['userProfiles', currentOrganizationId, currentUserId],
        queryFn: () => (currentOrganizationId && currentUserId)
            ? profileService.getUserProfilesData(currentOrganizationId, currentUserId)
            : Promise.resolve([]),
        enabled: !!currentOrganizationId && !!currentUserId, // Only run if we have both IDs
    });
    const isLoading = isUserLoading || isSessionLoading || isProfilesLoading;
    useDispatchHookEvent('useUserProfiles', {
        profiles,
        isLoading,
        error,
    });
    return {
        profiles: profiles || [],
        isLoading,
        error,
    };
};
//# sourceMappingURL=useUserProfiles.js.map